import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { match } from 'ts-pattern';
import ImportCsv from '@/features/import-csv';
import type { ExportApiUrl } from '@/features/import-csv/types';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { PublicIdType } from '../../add/-constants/publicIdType';
import usePublicIdNationalIdTableRows from './-hooks/usePublicIdNationalIdTableRows';
import usePublicIdTypeParam from './-hooks/usePublicIdTypeParam';
const PublicIdImportCsv = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const {
    publicIdType
  } = usePublicIdTypeParam();
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.publicIds.importCsv.publicIdType'
  });
  const {
    t: tCompleteDialog
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.publicIds.importCsv.completeDialog'
  });
  const title = match(publicIdType).with(PublicIdType.NATIONAL_ID, () => t('title.nationalId')).exhaustive();
  const useTableRows = match(publicIdType).with(PublicIdType.NATIONAL_ID, () => usePublicIdNationalIdTableRows).exhaustive();
  const exportApiUrl = match<keyof typeof PublicIdType, ExportApiUrl>(publicIdType).with(PublicIdType.NATIONAL_ID, () => '/v2/public-ids-csv/national-id' as ExportApiUrl).exhaustive();
  const exportFilename = match(publicIdType).with(PublicIdType.NATIONAL_ID, () => t('exportFilename.nationalId')).exhaustive();
  const templateTitle = match(publicIdType).with(PublicIdType.NATIONAL_ID, () => t('prepareCsvFile.templateTitle.nationalId')).exhaustive();
  const unit = match(publicIdType).with(PublicIdType.NATIONAL_ID, () => t('unit.nationalId')).exhaustive();
  const updateExisting = match(publicIdType).with(PublicIdType.NATIONAL_ID, () => t('prepareCsvFile.updateExisting.nationalId')).exhaustive();
  return <ImportCsv baseLink={`/public-ids/import-csv/${publicIdType}`} baseTitle={title} exportApiUrl={exportApiUrl} exportFilename={exportFilename} templateMessage={{
    templateTitle,
    updateExisting,
    completeLinkButton: tCompleteDialog('button')
  }} completeLinkUrl="/public-ids" unit={unit} search={search} navigate={navigate} useTableRows={useTableRows} />;
};
export const Route = createFileRoute('/_staff/public-ids/import-csv/$publicIdType')({
  component: PublicIdImportCsv,
  validateSearch: zodValidator(ImportCsvSearchSchema)
});